<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title>
        <v-toolbar>
          <v-toolbar-title>Simulador de Cuotas</v-toolbar-title>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
<template>
          <hr />
          <v-radio-group v-model="modalidad" inline>
            <v-radio label="Monto en Mano" value="capital" ></v-radio>
            <v-radio label="Monto por Cuota" value="cuota" ></v-radio>
          </v-radio-group>

</template>
          <v-row>
            <v-col cols="6">
              <!-- ImporteCuotas:{{ montoCuota  }} -->
              <v-autocomplete
                v-model="model.empresaId"
                :items="listEmpresas"
                autocomplete="disabled"
                item-text="nombre"
                item-value="id"
                label="Empresa"
                placeholder="Seleccione uno"
                :menu-props="{ minWidth: '200' }"
              ></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                v-model="model.canalVentaId"
                :items="listCanalesVentaDisponibles"
                no-data-text="Debe elegir una Empresa"
                item-text="nombre"
                item-value="id"
                label="Canal de Venta"
                placeholder="Seleccione uno"
                :menu-props="{ minWidth: '200' }"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-autocomplete
                v-model="model.productoId"
                :items="listProductosDisponibles"
                no-data-text="Debe elegir un Canal de Venta"
                :loading="loading"
                item-text="productoDescripcion"
                item-value="productoId"
                label="Producto"
                placeholder="Seleccione uno"
                :menu-props="{ minWidth: '200' }"
              ></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                v-model="model.planId"
                :items="listPlanesDisponibles"
                no-data-text="No hay planes disponibles para la Empresa y Producto seleccionados"
                item-text="nombre"
                item-value="id"
                label="Plan"
                placeholder="Seleccione uno"
                :menu-props="{ minWidth: '400' }"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row   v-if="modalidad == 'capital'">

            <v-col cols="4">
              <v-text-field
                v-model="montoEnMano"
                label="Monto en Mano"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-text-field v-model="gastos" label="Gastos"></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="montoAFinanciar"
                label="Monto a Financiar"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row   v-else>
            <v-col cols="4">
              <v-text-field
                v-model="montoCuota"
                label="Monto Cuota"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-row>
            <v-col cols="12">
              <v-btn width="420" color="success" @click="calcularOpcionesPlan"
                >Calcular Cuotas</v-btn
              >
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-row>
            <v-data-table
              :headers="headers"
              :items="opcionesCuotas"
              :loading="loadingCuotas"
              loading-text="Cargando Opciones..."
            >
              <template slot="no-data">
                <v-alert :value="true" icon="warning">
                  Ingrese un monto y presione Calcular Cuotas
                </v-alert>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-xs-left caption">{{ item.cuotas }}</td>
                  <td class="text-xs-left caption">
                    {{ item.importeCuota | currency }}
                  </td>
                  <td class="text-xs-left caption">{{ item.capital }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-row>

          <v-divider></v-divider>
          <v-alert color="warning" dark v-if="errorPolitica != ''">{{
            errorPolitica
          }}</v-alert>
        </v-container>
        <template v-if="$store.state.debugModeOn">
          Debug Info:
          <p></p>

          Model: {{ model }}
          <p></p>
        </template>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
'use strict';
import { http } from '@/axios';
import Vue from 'vue';
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

export default {
  data() {
    return {
      loading: false,
      modalidad:"capital",
      loadingCuotas: false,
      headers: [
        { text: 'Cuotas', value: 'cuotas', sortable: false },
        { text: 'Importe Cuota', value: 'importeCuota', sortable: false },
        { text: 'Capital', value: 'capital', sortable: false }
      ],
      model: { empresaId: 0, canalVentaId: 0, productoId: 0, planId: 0 },
      listEmpresas: [],
      listCanalesVenta: [],
      listProductosDisponibles: [],
      listPlanes: [],
      montoEnMano: 0,
      montoCuota: 0,
      gastos: 0,
      opcionesCuotas: [],
      errorPolitica: '',
    };
  },
  async created() {
    await this.loadEmpresas();
    this.loadCanalesVenta();
    this.loadPlanes();
  },
  watch: {
    'model.canalVentaId': async function() {
      //cargo los productos disponibles
      await this.loadProductosDisponibles();
    },
    'modalidad': async function() {
      //blanqueo los valores
      this.montoCuota = 0;
      this.montoEnMano = 0;
      this.gastos = 0;
      this.montoAFinanciar = 0;
    },
     
 /*"modalidad"*/

  },
  
  computed: {
    ...mapGetters(['user', 'UiCustomUserSettings']),
    listCanalesVentaDisponibles: function() {
      if (!this.listCanalesVenta || !this.model.empresaId) return [];

      const canalesVenta = this.listCanalesVenta.filter(
        (cv) => cv.empresaId == this.model.empresaId
      );
      if (canalesVenta.length > 0) {
        this.model.canalVentaId = this.UiCustomUserSettings
          .canalVentaPredeterminadoId
          ? this.UiCustomUserSettings.canalVentaPredeterminadoId
          : canalesVenta[0].id;
      }

      return canalesVenta;
    },
    listPlanesDisponibles: function() {
      if (!this.listPlanes || !this.model.productoId || !this.model.empresaId)
        return [];

      const planes = this.listPlanes.filter(
        (p) =>
          p.productoId == this.model.productoId &&
          p.empresaId == this.model.empresaId
      );

      if (planes.length > 0) {
        this.model.planId = planes[0].id;
      }

      return planes;
    },
    montoAFinanciar: function() {
      let enMano = parseFloat(this.montoEnMano);
      let gastos = parseFloat(this.gastos);

      if (isNaN(enMano) || isNaN(gastos) || gastos == 100) {
        return 0;
      } else {
        gastos = gastos / 100;
        let montoAFinanciar = enMano / (1 - gastos);

        return Math.round(montoAFinanciar + Number.EPSILON);
      }
    },
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get('empresas/');

        this.listEmpresas = result.list;
        this.model.empresaId = this.UiCustomUserSettings.empresaPredeterminadaId
          ? this.UiCustomUserSettings.empresaPredeterminadaId
          : this.listEmpresas[0].id;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          'canalesventa/habilitadosparausuario?usuarioId=' + this.user.id
        );

        this.listCanalesVenta = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadPlanes() {
      this.loading = true;
      try {
        //var result = await http.get('planes?empresaId=' + this.model.empresaId); // traigo todos
        var result = await http.get('planes'); // traigo todos

        this.listPlanes = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadProductosDisponibles() {
      if (this.model.canalVentaId == 0) return;

      this.opcionesPlanes = [];
      this.loading = true;
      try {
        var result = await http.get(
          'businesscore/productosdisponiblesparacredito' +
            '?empresaId=' +
            this.model.empresaId +
            '&canalVentaId=' +
            this.model.canalVentaId
        );

        let listProductos = result.list;
        this.listProductosDisponibles = listProductos.filter(
          (p) => p.estaDisponible
        );
        if (this.listProductosDisponibles.length > 0)
          this.model.productoId = this.listProductosDisponibles[0].productoId;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async calcularOpcionesPlan() {
      this.opcionesCuotas = [];
      this.errorPolitica = '';

      //Solo si la modalidad es "Capital"
      
      if (this.montoAFinanciar <= 0 && this.modalidad == "capital") {
        this.alertWarning('El monto a financiar debe ser mayor a 0');
        return;
      }
   
      if (this.montoCuota <= 0 && this.modalidad == "cuota") {
        this.alertWarning('El importe de la cuota debe ser mayor a 0');
        return;
      }


      this.loadingCuotas = true;
      try {
        var result = await http.get(
          'businesscore/calcularopcionesplanparacredito' +
            '?planId=' +
            this.model.planId +
            '&empresaId=' +
            this.model.empresaId +
            '&canalVentaId=' +
            this.model.canalVentaId +
            '&calificacionPersonaId=' +
            1 +
            '&politicaComercialId=' +
            1 +
            '&diaCobro=' +
            '0' +
            '&capital=' +
            this.montoAFinanciar +
            '&importeCuotaMaximo=' +
            this.montoCuota +
            '&ingresoMensual=' +
            0 +
            '&fechaCarga=' +
            this.$moment(new Date()).format('YYYY-MM-DD') +
            '&excepcionAprobada=true'
        );

        this.opcionesCuotas = result.list;

        if (result.list.length == 0) {
          this.alertWarning(
            'No se encontraron opciones de cuota para el plan seleccionado.'
          );
        }
      } catch (error) {
        if (JSON.stringify(error).includes('Politica')) {
          this.errorPolitica = error;
        } else {
          // Error
          this.alertError(error);
        }
      }
      this.loadingCuotas = false;
    },
  },
};
</script>
